/** Fabric books referential. */
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/shared/api/client';
import {
  namedItemSchema,
  type NamedItem,
  type NamedItemService,
} from '../named-items/api';

export type FabricBook = NamedItem;

export const fabricBooksQueryKey = ['fabric-books'] as const;

const listFabricBooks = () =>
  api.get<FabricBook[]>('fabric-book', { schema: z.array(namedItemSchema) });

export const fabricBooksQueryOptions = () =>
  queryOptions({
    queryKey: fabricBooksQueryKey,
    queryFn: listFabricBooks,
    retry: false,
  });

export const fabricBookService: NamedItemService = {
  label: 'fabric book',
  queryKey: fabricBooksQueryKey,
  list: listFabricBooks,
  create: (name) => api.post<FabricBook>('fabric-book', { name }),
  update: (id, name) =>
    api.put<FabricBook>(`fabric-book/${encodeURIComponent(id)}`, { name }),
  delete: (id) => api.delete<unknown>(`fabric-book/${encodeURIComponent(id)}`),
};
